import type { CityConfig } from "../city-template/types";

export const raleighConfig: CityConfig = {
  city: "Raleigh",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "raleigh",
  route: "/cities/raleigh",
  title: "Emergency Passport Raleigh, NC | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Raleigh, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Wake County and the Research Triangle. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Raleigh, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Raleigh and Research Triangle area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Raleigh%20North%20Carolina%20skyline%20at%20sunset%20with%20the%20North%20Carolina%20State%20Capitol%20building%20visible%2C%20modern%20downtown%20buildings%20reflecting%20warm%20golden%20light%2C%20oak%20trees%20lining%20the%20streets%20in%20the%20foreground%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20lush%20green%20parks%20and%20open%20spaces%20around%20the%20city%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20natural%20green%20landscape%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=raleigh-hero-nc-001&orientation=landscape",
  heroImageAlt: "Raleigh North Carolina downtown skyline at sunset with the Capitol building",
  geoPosition: "35.7796;-78.6382",
  geoPlacename: "Raleigh, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 400 miles from Raleigh via I-85",
  },
  nearbyCitiesZips: [
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Cary", zips: "27511, 27512, 27513, 27518, 27519" },
    { name: "Durham", zips: "27701–27717" },
    { name: "Chapel Hill", zips: "27514, 27515, 27516, 27517" },
    { name: "Apex", zips: "27502, 27523, 27539" },
    { name: "Garner", zips: "27529" },
    { name: "Wake Forest", zips: "27587, 27588" },
    { name: "Morrisville", zips: "27560" },
    { name: "Holly Springs", zips: "27540" },
    { name: "Fuquay-Varina", zips: "27526" },
    { name: "Knightdale", zips: "27545" },
    { name: "Clayton", zips: "27520, 27527, 27528" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Raleigh departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Research Triangle Hub", desc: "Serving Raleigh, Durham, Chapel Hill, and the entire Triangle" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Fast passport renewal in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Emergency passport help in Winston-Salem, NC", route: "/cities/winston-salem" },
    { name: "Urgent passport services in Durham, NC", route: "/cities/durham" },
    { name: "Same-day passport help in Apex, NC", route: "/cities/apex" },
    { name: "Passport courier services in Chapel Hill, NC", route: "/cities/chapel-hill" },
    { name: "Expedited passport services in Rocky Mount, NC", route: "/cities/rocky-mount" },
    { name: "Fast passport renewal in Goldsboro, NC", route: "/cities/goldsboro" },
    { name: "Same-day passport help in Wake Forest, NC", route: "/cities/wake-forest" },
    { name: "Urgent passport services in Wilson, NC", route: "/cities/wilson" },
    { name: "Passport courier services in Holly Springs, NC", route: "/cities/holly-springs" },
    { name: "Passport courier services in Fuquay-Varina, NC", route: "/cities/fuquay-varina" },
    { name: "Emergency passport help in Morrisville, NC", route: "/cities/morrisville" },
    { name: "Passport courier services in Garner, NC", route: "/cities/garner" },
    { name: "Emergency passport help in Clayton, NC", route: "/cities/clayton" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Raleigh remotely via secure courier. We do not have a walk-in office in Raleigh — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Wake County and the Research Triangle area travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Wake County and the Research Triangle including Durham and Orange counties",
  serviceAreaIntro: "From downtown Raleigh to the suburbs of Cary, Apex, and Garner, from North Hills to Wake Forest and Morrisville — Fast Passport Center serves the entire Research Triangle region. We regularly help travelers from Durham, Chapel Hill, and Holly Springs get their passports fast.",
  nearbyCitiesIntro: "We serve all Raleigh neighborhoods and the surrounding Research Triangle area including Cary, Durham, Chapel Hill, Apex, Garner, Wake Forest, Morrisville, Holly Springs, Fuquay-Varina, Knightdale, and Clayton. If you are anywhere in Wake, Durham, or Orange counties, we have you covered.",
  howItWorksIntro: "Most Raleigh travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Raleigh travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Raleigh and Research Triangle travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Raleigh? Here are the most common ones we hear from Wake County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Raleigh international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Michael R.",
      location: "Raleigh, NC",
      rating: 5,
      text: "My passport expired two weeks before our honeymoon in Greece. Fast Passport Center had my renewal in 4 days. Never had to leave the Triangle. Outstanding service.",
      service: "Passport Renewal",
    },
    {
      name: "Amanda C.",
      location: "Cary, NC",
      rating: 5,
      text: "Emergency passport for a family emergency in India. Got it in 32 hours. The team was compassionate and professional. I could not have made that flight without them.",
      service: "Emergency Passport",
    },
    {
      name: "James W.",
      location: "Durham, NC",
      rating: 5,
      text: "Business trip to Tokyo came up with 6 days notice. They got me a passport in 3 business days. The dedicated agent made the whole process effortless.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa P.",
      location: "Chapel Hill, NC",
      rating: 5,
      text: "First passport for my daughter before her study abroad in Spain. Fast Passport Center guided us through every step and had it ready in 5 days. Highly recommend.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "raleigh-1",
      name: "Raleigh Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 Fayetteville St",
      city: "Raleigh",
      state: "NC",
      zip: "27601",
      phone: "(919) 896-5310",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Raleigh",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Raleigh facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "raleigh-2",
      name: "Cary Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1813 N Harrison Ave",
      city: "Cary",
      state: "NC",
      zip: "27513",
      phone: "(919) 467-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Raleigh suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Cary and Morrisville residents. Less crowded than downtown. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "raleigh-3",
      name: "Durham Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "323 E Chapel Hill St",
      city: "Durham",
      state: "NC",
      zip: "27701",
      phone: "(919) 683-6842",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Durham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Durham County and west Wake County. Duke University area. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "raleigh-4",
      name: "Chapel Hill Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "179 E Franklin St",
      city: "Chapel Hill",
      state: "NC",
      zip: "27514",
      phone: "(919) 967-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Orange County, UNC Chapel Hill area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Chapel Hill, Carrboro, and Orange County. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "raleigh-5",
      name: "Wake County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "316 Fayetteville St",
      city: "Raleigh",
      state: "NC",
      zip: "27601",
      phone: "(919) 792-4000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Wake County Courthouse, downtown Raleigh",
      website: "https://www.wakegov.com/",
      websiteLabel: "Wake County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "raleigh-6",
      name: "Apex Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "640 E Williams St",
      city: "Apex",
      state: "NC",
      zip: "27502",
      phone: "(919) 362-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Southwest Raleigh suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Apex and Holly Springs area. Ample parking. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Raleigh photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wake County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Raleigh applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Wake County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Raleigh travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Raleigh." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Raleigh address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Raleigh before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Raleigh for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 6 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Raleigh?", a: "Fast Passport Center offers fast passport renewal in Raleigh in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Raleigh?", a: "The nearest regional passport agency to Raleigh is the Atlanta Passport Agency, approximately 400 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Raleigh without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Raleigh?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 6 hours from Raleigh — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Wake County residents." },
    { q: "Do you serve the entire Research Triangle?", a: "Absolutely. Fast Passport Center serves the entire Research Triangle including Raleigh, Durham, Chapel Hill, Cary, Apex, Morrisville, Holly Springs, Fuquay-Varina, Wake Forest, Garner, and Clayton. Our courier service works seamlessly from any address in Wake, Durham, or Orange counties." },
    { q: "Can I expedite a child passport in Raleigh?", a: "Yes. Fast Passport Center expedites child passports in Raleigh for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Wake County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Raleigh with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Wake County Register of Deeds',
      description: 'Marriage licenses and records for Wake County. Apply in person or request certified copies.',
      url: 'https://www.wake.gov/departments-government/register-deeds',
    },
    {
      label: 'Wake County Clerk of Superior Court',
      description: 'Divorce records and decrees for Wake County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/wake-county/wake-county-clerk-of-superior-court',
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Downtown Raleigh", address: "201 S Wilmington St, Raleigh, NC 27601", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — North Hills", address: "4201 Lassiter Mill Rd, Raleigh, NC 27609", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Cary", address: "1101 N Harrison Ave, Cary, NC 27513", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Raleigh", address: "4421 Six Forks Rd, Raleigh, NC 27609", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Durham", address: "2609 Erwin Rd, Durham, NC 27705", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Chapel Hill", address: "1720 Fordham Blvd, Chapel Hill, NC 27514", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Apex", address: "1011 E Williams St, Apex, NC 27502", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart — Wake Forest", address: "2114 S Main St, Wake Forest, NC 27587", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Raleigh Central",
      address: "1100 New Bern Ave, Raleigh, NC 27601",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Cary",
      address: "2991 E Chatham St, Cary, NC 27518",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Durham",
      address: "3620 Shannon Rd, Durham, NC 27707",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Durham and Orange County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Garner",
      address: "4031 Jones Sausage Rd, Garner, NC 27529",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves south Wake County. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "15 miles northwest of downtown Raleigh",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international hub serving the Research Triangle. Direct flights to London, Paris, Cancun, and major domestic destinations. Preferred airport for Raleigh, Durham, and Chapel Hill travelers.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "70 miles west of Raleigh",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for west Wake County residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "150 miles southwest of Raleigh",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major hub with additional international routes. American Airlines hub. Consider for long-haul international travel.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
};